import { useState, useRef, useEffect } from "react";
import './Recharge.less'
// 工具
import { jumpPage, onToUserPage } from "@/utils/common";
// 组件
import { Dialog, Toast, Image } from 'antd-mobile'
import { DialogShowHandler } from 'antd-mobile/es/components/dialog'
import NavBar from '@/component/NavBar/NavBar';
// api
import { getPayMethod, getProductList, postTopUp, createOrder, getRechargeInfo, getChannelList } from "@/api/recharge";
import { getActivityList } from '@/api/activity'
import { CashierListData } from '@/interface/recharge'
// 图片
import diamondPng from "@/image/recharge/diamond.svg";
import questionPng from '@/image/recharge/question.svg'
import uncheck_box from '@/image/common/uncheck_box.svg'
import check_box from '@/image/common/check_box.svg'
import down_arrow from '@/image/common/down_arrow.webp'

const Recharge = () => {
  const handler = useRef<DialogShowHandler>() // 确认充值弹框
  const handler2 = useRef<DialogShowHandler>() // 小酒窝充值协议弹框
  const handler3 = useRef<DialogShowHandler>() // 今日消费限额/等级充值限额
  const [active, setActive] = useState(0)
  const [method, setMethod] = useState('AliPay')
  const [env] = useState(process.env.REACT_APP_ENV_VERSION)
  // const inputRef = useRef(null);
  let ui = localStorage.getItem('userInfo')
  ui = ui && ui !== 'undefined' ? JSON.parse(localStorage.getItem('userInfo') as string) : {}
  const [userInfo] = useState<any>(ui)
  const [listOfAmounts, setListOfAmounts] = useState([{
    amount: 0,
    description: "",
    diamond_num: 0,
    product_code: "",
    points: 0,
    corner_color_list: [], // ["#FFFF5A1B","#FFFFA21A"] 两个的话就是渐变
    corner_text: '', // 赠送20如意令
  }])
  const [dailyTopUp, setDailyTopUp] = useState<string>('')
  const [aggre_money, setAggreMoney] = useState<number>(0)
  const [hasActivity, setHasActivity] = useState<string>('')
  const [check, setCheck] = useState<boolean>(false)
  const [unfold, setUnfold] = useState<boolean>(false) // 是否展开支付方式
  const [listOfPay, setListOfPay] = useState<Array<CashierListData>>([])

  useEffect(() => {
    getProductList().then(e => {
      setListOfAmounts(e.list)
      setDailyTopUp(e.image_url)
      setAggreMoney(e.aggre_money)
    })

    getActivityList({ activity_type: 'LC' }).then(e => {
      setHasActivity(e[0]?.activity_code)
    }).catch(() => {})

    getRechargeInfo().then(e => {
      // 协议标签 Y-自动勾选  N-手动勾选
      setCheck(e.agreement_flag === 'Y')
    }).catch(() => {})

    getChannelList().then(e => {
      setListOfPay(e)
    })
  }, [])

  // function getValue(input: any) {
  //   if (typeof input === 'object') return input.value
  // }

  // const accountDialog = () => {
  //   handler.current = Dialog.show({
  //     content: (
  //       <>
  //         <h3 className="dialog-title">充值账号</h3>
  //         <section>
  //           <input ref={inputRef} type="number" name="user_id" placeholder="请输入小酒窝语音账户ID" />
  //         </section>
  //       </>
  //     ),
  //     // closeOnAction: true,
  //     actions: [
  //       [
  //         {
  //           key: 'cancel',
  //           text: '取消',
  //           onClick: () => {
  //             handler.current?.close()
  //           },
  //         },
  //         {
  //           key: 'confirm',
  //           text: '确定',
  //           bold: true,
  //           disabled: false,
  //           onClick: () => {
  //             const user_id = Number(getValue(inputRef.current))
  //             if (user_id) {
  //               getUserViewInfo(user_id).then((e:any) => {
  //                 // 存在localStorage里面是被充值账户的信息，而存在redux里面的是本账户的信息
  //                 localStorage.setItem('userInfo', JSON.stringify(e))
  //                 setUserInfo(e)
  //                 handler.current?.close()
  //               }).catch(() => {})
  //             } else Toast.show('请先填写账户ID')
  //           },
  //         },
  //       ],
  //     ],
  //   })
  // }

  // 获取支付code
  const triggerGetPayMethod = () => {
    return getPayMethod(method === 'Wechat' ? 'wechat_miniapp' : 'h5').then(e => e);
  }

  // 支付宝支付
  const triggerTopUp = async () => {
    const data = {
      client_os: method === 'Wechat' ? 'wechat_miniapp' : 'h5',
      product_code: listOfAmounts[active].product_code,
      to_user_id: userInfo.user_id,
      // diamond_num: mount.value,
      // amount: money.value * 100,
    }

    const payMethod = await triggerGetPayMethod()
    postTopUp(data).then(payResult => {
      if (payMethod?.asset_type_code && payMethod?.asset_product_code && payResult?.biz_no) {
        const { asset_type_code, asset_product_code } = payMethod;
        const { user_id, biz_no, amount, biz_notify_url, expire_at_time, third_user_id, auth_app_id } = payResult;

        if (method === 'Wechat') {
          // 正式版为release，体验版为trial，开发版为develop
          const queryString = `biz_no=${biz_no}&amount=${amount}&user_id=${userInfo.user_id}`;

          try {
            window.location.href = `weixin://dl/business/?appid=wx395ef242680bc1a6&path=pages/recharge/recharge&query=${encodeURIComponent(queryString)}&env_version=${env}`
          } catch (error:any) {
            Toast.show('请先安装最新版本的小酒窝语音！')
          }

          return
        }

        createOrder({
          asset_type_code,
          asset_product_code,
          uid: user_id,
          biz_no,
          goods_name: `${listOfAmounts[active].diamond_num}钻石`,
          goods_desc: '',
          amount,
          biz_notify_url,
          expire_at_time,
          client_os: method === 'Wechat' ? 'wechat_miniapp' : 'h5',
          return_url: window.location.href.split('?')[0],
          third_user_id,
          auth_app_id,
        }).then(data => {
          // 触发支付宝支付api
          try {
            // window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(data.url)}`
            if (data.alipay_response.url) window.location.href = `${data.alipay_response.url}`
          } catch (error:any) {
            Toast.show(error)
          }
        })
      } else {
        triggerGetPayMethod()
        if (payResult?.biz_no) Toast.show('支付方式获取中，请稍后再试！')
      }
    }).catch(({ code, msg }) => {
      if (code === 501) { // 501: 今日消费限额
        errorDialog(code, msg)
      } else if (code === 502) { // 502: 等级充值限额
        errorDialog(code, msg)
      }
    })
  }

  const readAgreement = () => {
    handler2.current = Dialog.show({
      className: 'recharge-agreement-dialog',
      content: (
        <>
          <h3 className="dialog-title">小酒窝充值协议</h3>
          <section>
            <p onClick={() => setCheck(!check)}>我已详细阅读并同意</p>
            <span onClick={() => jumpPage('/recharge-agreement')}>《小酒窝充值协议》</span>
          </section>
        </>
      ),
      // closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '不同意',
            onClick: () => {
              handler2.current?.close()
            },
          },
          {
            key: 'confirm',
            text: '同意并支付',
            bold: true,
            onClick: () => {
              setCheck(true)
              confirmPay()
              handler2.current?.close()
            },
          },
        ],
      ],
    })
  }

  const confirmPay = () => {
    // if (!check) return Toast.show('请先查看并同意充值协议')
    handler.current = Dialog.show({
      content: (
        <>
          <h3 className="dialog-title">确认充值</h3>
          <section>
            <p>是否为ID为 <span style={{fontWeight:'bold'}}>{userInfo.user_id}</span>，昵称为 <span style={{fontWeight:'bold'}}>{userInfo.user_nickname}</span> 的账号充值￥ <span style={{color:'red'}}>{listOfAmounts[active]?.amount}</span>？</p>
          </section>
        </>
      ),
      // closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
            onClick: () => {
              handler.current?.close()
            },
          },
          {
            key: 'confirm',
            text: '确定',
            bold: true,
            onClick: () => {
              triggerTopUp()
              handler.current?.close()
            },
          },
        ],
      ],
    })
  }

  const errorDialog = (code: number, msg: string) => {
    handler3.current = Dialog.show({
      className: 'error-dialog',
      content: (
        <>
          <h3 className="dialog-title">{msg.split('|')[0]}</h3>
          <section>
            <p>{msg.split('|')[1]}</p>
          </section>
        </>
      ),
      // closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '知道了',
            onClick: () => {
              handler3.current?.close()
            },
          },
          {
            key: 'confirm',
            text: `${code === 501 ? '修改限额' : '联系客服'}`,
            bold: true,
            onClick: () => {
              onToUserPage(0, code === 501 ? 'consume_set' : 'customer_service')
              handler3.current?.close()
            },
          },
        ],
      ],
    })
  }

  const buttonClick1 = () => {
    jumpPage('/value-notice')
  }

  return (
    <div className="recharge-content-page">
      <NavBar title="充值" rightButton="充值说明" imageUrl={questionPng} buttonClick={buttonClick1} />

      <section className="recharge-content">
        <h3>账户充值</h3>
        <nav className="account-info">
          {
            userInfo.user_id ?
            <>
              <aside>
                <img className="head-portrait" src={userInfo.avatar} alt="" />
                <div>
                  <h3>{userInfo.user_nickname}</h3>
                  <p>ID:{userInfo.user_id}</p>
                </div>
              </aside>
              {/* <span onClick={accountDialog}>切换账号</span> */}
            </> : ''
            // <button className="middle-btn primary-botton" onClick={accountDialog}>选择账户</button>
          }
        </nav>

        <h3>
          选择充值金额
          <span>*未成年人禁止充值消费</span>
        </h3>
        <p>平台不会以任何形式要求用户转账汇款、索要账号信息(账号、密码、验证码等)、向他人账号充值以及许诺充值返利活动，请大家提高警惕，谨防诈骗!</p>
        {
          hasActivity && dailyTopUp &&
          <div className="dailyTopUp" onClick={() => jumpPage('/top-up/total-top-up')}>
            <img src={dailyTopUp} alt="" />
            <p>每日充值，最高额外获得价值<span>{aggre_money}</span>元豪华专属礼包</p>
          </div>
        }
        <ul>
          {listOfAmounts.map((item, index) => (
            <li className={active === index ? 'active-btn' : ''} key={index} onClick={() => setActive(active => active = index)}>
              <img src={diamondPng} alt="" />
              <span>{item.diamond_num}</span>
              <span>￥{item.amount}.00</span>
              {item.points ? <span className="points">获得{item.points}积分</span> : ''}
              {item.corner_text ? <span className="superscript" style={{ background: `linear-gradient(to right, ${item.corner_color_list[0]}, ${item.corner_color_list[item.corner_color_list.length - 1]})` }}>{item.corner_text}</span> : ''}
            </li>
          ))}
          <li />
        </ul>

        <h3>选择支付方式</h3>
        <nav className={'pay-methods' + (unfold ? ' is_hidden' : '')}>
          {/* {methodOfPay.filter(e => !isiOS || e.value !== 'Wechat' ).map((item, index) => ( */}
          {listOfPay.filter(e => e.is_hidden === 'N' || unfold).map((item, index) => (
            <div key={index} className={(item.recommendation_text ? 'has_recommend' : '') + (listOfPay.length <= 1 ? ' only_one' : '') + (item.discount_text ? '' : ' no_discount_text') + ' pay_btn'} onClick={() => setMethod(method => method = item.asset_type_code)}>
              <img src={item.icon} alt="" />

              <section>
                <section>
                  <h4>{item.asset_type_name} 
                    {
                      item.recommendation_text ?
                      <span className="tag">{ item.recommendation_text }</span> : ''
                    }
                  </h4>
                  {
                    item.discount_text ? 
                    <div className="notify-text">{ item.discount_text }</div> : ''
                  }
                </section>

                <Image src={method === item.asset_type_code ? check_box : uncheck_box} fit='contain' />
              </section>
            </div>
          ))}

          {
            unfold || listOfPay.length <= 1 ? <></> :
            <footer>
              <p onClick={() => setUnfold(!unfold)}>展开更多支付方式</p>
              <Image src={down_arrow} className={unfold ? 'up_arrow' : 'down_arrow'} fit='contain' onClick={() => setUnfold(!unfold)} />
            </footer>
          }
        </nav>

        <button disabled={!userInfo.user_id} className="big-btn" onClick={() => check ? confirmPay() : readAgreement()}>确认支付<span>({listOfAmounts[active].amount}元)</span></button>

        <footer>
          <Image src={check ? check_box : uncheck_box} fit='contain' onClick={() => setCheck(!check)} />
          <p onClick={() => setCheck(!check)}>我已详细阅读并同意</p>
          <span onClick={() => jumpPage('/recharge-agreement')}>《小酒窝充值协议》</span>
        </footer>
      </section>
    </div>
  )
}

export default Recharge